import { get, find, includes } from 'lodash';

export const isLoadingEvent = (state, eventId) => {
  const events = get(state, 'clubEvents.loadingEvents', []);
  return includes(events, eventId);
};

export const isLoadingAttendance = (state, eventId) => {
  const events = get(state, 'clubEvents.loadingAttendances', []);
  return includes(events, eventId);
};

export const hasLoadedAttendance = (state, eventId) => {
  const events = get(state, 'clubEvents.loadedAttendances', []);
  return includes(events, eventId);
};

export const hasAttemptedEventLoad = (state, eventId) => {
  const events = get(state, 'clubEvents.hasAttemptedLoad', []);
  return includes(events, eventId);
};

export const getEvent = (state, eventId) => {
  const events = get(state, 'clubEvents.events', []);
  return find(events, { id: eventId });
};

export const getEventAttendances = (state, eventId) =>
  get(state, `clubEvents.eventAttendances[${eventId}]`, []);

export const getEventAttendees = (state, eventId) =>
  get(state, `clubEvents.eventAttendees[${eventId}]`, []);
